import { Timestamp } from "firebase/firestore";

export const timestamp = Timestamp.now();
